<template>
  <div>
    <index-principal />
    <create-principal />
    <view-principal />
  </div>
</template>

<script>
  import IndexPrincipal from '../../../components/setup/principals/IndexPrincipal';
  import CreatePrincipal from '../../../components/setup/principals/CreatePrincipal';
  import ViewPrincipal from '../../../components/setup/principals/ViewPrincipal';

  //update

  export default {
    name: 'Principals',
    components:{
      'index-principal': IndexPrincipal,
      'create-principal': CreatePrincipal,
      'view-principal' : ViewPrincipal
    }
  };
</script>

<style scoped>

</style>